export enum ModalType {
  CONNECT_WALLET = 'CONNECT_WALLET',
  SET_TRANSFER_CODE = 'SET_TRANSFER_CODE',
}
